import request from '@/utils/request'
import qs from 'qs'

export function getDailyData(data) {
    data = qs.stringify(data)
    return request({
        url: '/home/getDailyDataNew',
        method: 'post',
        data
    })
}

export function getDailyDataYearNew(data) {
    data = qs.stringify(data)
    return request({
        url: '/home/getDailyDataYearNew',
        method: 'post',
        data
    })
}

export function getHr(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/queryHrDataNew',
        method: 'post',
        data
    })
}

export function queryHrDataByYear(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/queryHrDataByYear',
        method: 'post',
        data
    })
}

export function getBasicHr(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/getBasicHr',
        method: 'post',
        data
    })
}

export function getLatestEcgData(data) {
    data = qs.stringify(data)
    return request({
        url: '/ecgInfo/getLatestEcgData',
        method: 'post',
        data
    })
}

export function getSleepByDate(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/getSleepByDate',
        method: 'post',
        data
    })
}

export function getSleepByRange(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/getSleepByRange',
        method: 'post',
        data
    })
}

export function getBos(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/getBos',
        method: 'post',
        data
    })
}

export function getPressure(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/getPressure',
        method: 'post',
        data
    })
}

export function queryFitnessAge(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/queryFitnessAge',
        method: 'post',
        data
    })
}

export function queryStaminaLevel(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/queryStaminaLevel',
        method: 'post',
        data
    })
}

export function queryTrainingLoad(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/queryTrainingLoad',
        method: 'post',
        data
    })
}

export function queryTrainingStatus(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/queryTrainingStatus',
        method: 'post',
        data
    })
}

export function queryVo2max(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/queryVo2max',
        method: 'post',
        data
    })
}

export function queryLactate(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/queryLactate',
        method: 'post',
        data
    })
}

export function queryForecastNew(data) {
    data = qs.stringify(data)
    return request({
        url: '/healthInfo/queryForecastNew',
        method: 'post',
        data
    })
}

export function getWaterCount(data) {
    data = qs.stringify(data)
    return request({
        url: '/app/getWaterCount',
        method: 'post',
        data
    })
}

export function getWaterCountList(data) {
    data = qs.stringify(data)
    return request({
        url: '/app/getWaterCountList',
        method: 'post',
        data
    })
}

export function getWaterCountYear(data) {
    data = qs.stringify(data)
    return request({
        url: '/app/getWaterCountYear',
        method: 'post',
        data
    })
}

export function uploadWater(data) {
    data = qs.stringify(data)
    return request({
        url: '/app/uploadWater',
        method: 'post',
        data
    })
}

export function dailyDataNew(data) {
    data = qs.stringify(data)
    return request({
        url: '/home/dailyDataNew',
        method: 'post',
        data
    })
}

export function updateTarget(data) {
    data = qs.stringify(data)
    return request({
        url: '/user/userInfo/update',
        method: 'post',
        data
    })
}

export function getMonthDailyData(data) {
    data = qs.stringify(data)
    return request({
        url: '/home/getMonthDailyData',
        method: 'post',
        data
    })
}

export function getBasicReport(data) {
    data = qs.stringify(data)
    return request({
        url: '/home/getBasicReport',
        method: 'post',
        data
    })
}

export function getWeightCountList(data) {
    data = qs.stringify(data)
    return request({
        url: '/app/getWeightCountList',
        method: 'post',
        data
    })
}

export function getWeightCountYear(data) {
    data = qs.stringify(data)
    return request({
        url: '/app/getWeightCountYear',
        method: 'post',
        data
    })
}

export function uploadWeight(data) {
    data = qs.stringify(data)
    return request({
        url: '/app/uploadWeight',
        method: 'post',
        data
    })
}

export function uploadHeight(data) {
    data = qs.stringify(data)
    return request({
        url: '/app/uploadHeight',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/status.js